import React from "react";
import {
  ArrayField,
  Datagrid,
  Labeled,
  ShowProps,
  TextField,
  UrlField,
} from "react-admin";
import { Grid, Typography } from "@material-ui/core";
import SanitizedGrid from "components/SanitizedGrid";
import CustomDateField from "components/CustomDateField";
import OwnershipField from "components/OwnershipField";
import StatusField from "../../components/StatusField";

const Summary = (props: ShowProps) => {
  return (
    <>
      <SanitizedGrid container spacing={2}>
        <Grid item xs={12}>
          <Typography variant="h6">Vehicle Detail</Typography>
        </Grid>

        <Grid item xs={3}>
          <Labeled source="Registration Company">
            <TextField source="registrationCompany" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={2}>
          <Labeled source="Registration Date">
            <CustomDateField source="registrationDate" />
          </Labeled>
        </Grid>
        <Grid item xs={2}>
          <Labeled source="Deregistration Date">
            <CustomDateField source="deRegistrationDate" />
          </Labeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <Grid item xs={3}>
          <Labeled source="Plate Number">
            <TextField source="plateNumber" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={9}></Grid>

        <Grid item xs={2}>
          <Labeled source="Chassis Number">
            <TextField source="chassisNumber" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={2}>
          <Labeled source="Engine Number">
            <TextField source="engineNumber" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={8}></Grid>

        <OwnershipField />

        <Grid item xs={3}>
          <Labeled source="Livery">
            <TextField source="livery" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="Status">
            <StatusField source="status" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={3}>
          <Labeled source="Iu Number">
            <TextField source="iuNumber" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={3}>
          <Labeled source="Old Iu Number">
            <TextField source="iuNumberOld" emptyText="-" />
          </Labeled>
        </Grid>
        <Grid item xs={6}></Grid>

        <Grid item xs={12}>
          <Typography variant="h6">Document Details</Typography>
        </Grid>

        <Grid item xs={6}>
          <ArrayField source="documents" fieldKey="id">
            <Datagrid
              empty={<Typography variant="body2">No Result found</Typography>}
            >
              <TextField source="type" emptyText="-" />
              <TextField source="serialNumber" emptyText="-" />
              <CustomDateField source="expiryDate" />
              <UrlField source="fileUrl" emptyText="-" />
            </Datagrid>
          </ArrayField>
        </Grid>
        <Grid item xs={6}></Grid>
      </SanitizedGrid>
    </>
  );
};

export default Summary;
